<template>
  <div class="home-wrapper">
    <!-- 首页的头部 -->
    <Head
      page="首页"
      :menuCode="menuCode"
      @getUserInfo="getUserInfo"
      :menuInfo="menuInfo"
      @userRole="getZhsRole"
      :isLogin="isLogin"
    />
    <!-- 轮播banner -->
    <BannerList
      v-visible="val => setVisible('banner', val)"
      :class="['animate-wrap', { visible: visibleComponents.banner }]"
      :userRole="zhsRole"
      :userInfo="userInfo"
      v-if="bannerItem && bannerItem.home_open"
    />
    <!-- 数据大屏 -->
    <div v-if="false" class="home-list-content">
      <LargeScreen
        v-visible="val => setVisible('largeScreen', val)"
        :class="['animate-wrap', { visible: visibleComponents.largeScreen }]"
        v-if="spocItem && spocItem.home_open"
      />
    </div>
    <!-- 完全学分制改革 -->
    <div v-if="false" class="home-list-content">
      <CreditReform
        v-visible="val => setVisible('creditReform', val)"
        :class="['animate-wrap', { visible: visibleComponents.creditReform }]"
        v-if="spocItem && spocItem.home_open"
      />
    </div>
    <!-- AI应用中心 -->
    <div class="home-list-content back-img">
      <div class="mask"></div>
      <AITeachApp
        :zhsRole="zhsRole"
        v-visible="val => setVisible('AITeachApp', val)"
        :class="['animate-wrap', { visible: visibleComponents.AITeachApp }]"
        v-if="spocItem && spocItem.home_open"
      />
    </div>
    <!-- AI智慧课程 -->
    <div class="home-list-content back-img">
      <div class="mask"></div>
      <KnowledgeMap
        v-visible="val => setVisible('knowledgeMap', val)"
        :class="['animate-wrap', { visible: visibleComponents.knowledgeMap }]"
        v-if="moocItem[1] && moocItem[1].home_open"
        :menu="moocItem[1]"
        :userInfo="userInfo"
        :zhsRole="zhsRole"
      />
    </div>
    <!-- spoc课程 -->
    <div v-if="false" class="home-list-content">
      <SpocCourse
        v-visible="val => setVisible('spocCourse', val)"
        :class="['animate-wrap', { visible: visibleComponents.spocCourse }]"
        v-if="spocItem && spocItem.home_open"
        :menu="spocItem"
        :userInfo="userInfo"
        :zhsRole="zhsRole"
      />
    </div>
    <!-- MOOC开放课 -->
    <div class="home-list-content">
      <Course
        v-visible="val => setVisible('course', val)"
        :class="['animate-wrap', { visible: visibleComponents.course }]"
        v-if="moocItem[0] && moocItem[0].home_open"
        :menu="moocItem[0]"
        :userInfo="userInfo"
        :zhsRole="zhsRole"
      />
    </div>
    <!-- 优秀作品展 -->
    <div class="home-list-content">
      <ExcellentVideo
        v-visible="val => setVisible('excellentVideo', val)"
        :class="['animate-wrap', { visible: visibleComponents.excellentVideo }]"
        v-if="spocItem && spocItem.home_open"
      />
    </div>
    <!-- 通知公告 -->
    <div class="home-list-content">
      <News
        v-visible="val => setVisible('news', val)"
        :class="['animate-wrap', { visible: visibleComponents.news }]"
        v-if="newsItem && newsItem.home_open"
        :menu="newsItem"
        :zhsRole="zhsRole"
      />
    </div>
    <!-- 名师列表 -->
    <div class="home-list-content back-img back-img-1">
      <div class="mask"></div>
      <TeacherList
        v-visible="val => setVisible('teacherList', val)"
        :class="['animate-wrap', { visible: visibleComponents.teacherList }]"
        v-if="teacherItem && teacherItem.home_open"
        :menu="teacherItem"
      />
    </div>
    <!-- 数据展示 -->
    <div class="home-list-content back-img">
      <div class="mask"></div>
      <TeacherData
        v-visible="val => setVisible('teacherData', val)"
        :class="['animate-wrap', { visible: visibleComponents.teacherData }]"
        v-if="dataItem && dataItem.home_open"
        :menu="dataItem"
        :visible="visibleComponents.teacherData"
      />
    </div>
    <Footer v-if="bannerItem && bannerItem.home_open" />
  </div>
</template>

<script>
import Head from './../components/Head'
import BannerList from './components/BannerList'
import LargeScreen from './components/LargeScreen'
import CreditReform from './components/CreditReform.vue'
import appCenter from './components/appCenter.vue'
import Course from './components/Course'
import KnowledgeMap from './components/KnowledgeMap.vue'
import SpocCourse from './components/SpocCourse.vue'
import AITeachApp from './components/AITeachApp.vue'
import News from './components/News'
import ExcellentVideo from './components/ExcellentVideo.vue'
import TeacherList from './components/TeacherList'
import TeacherData from './components/TeachData.vue'
import Footer from './../components/Footer'
export default {
  components: {
    Head,
    BannerList,
    LargeScreen,
    CreditReform,
    appCenter,
    Course,
    KnowledgeMap,
    SpocCourse,
    AITeachApp,
    News,
    ExcellentVideo,
    TeacherList,
    TeacherData,
    Footer
  },
  provide() {
    return {
      uuid: () => this.uuid,
      userId: () => this.userId
    }
  },
  // 在组件中定义自定义指令
  directives: {
    visible: {
      mounted(el, binding) {
        const observer = new IntersectionObserver(
          entries => {
            entries.forEach(entry => {
              if (entry.isIntersecting) {
                // 当元素进入视口时，调用绑定的方法
                binding.value(true)
                observer.unobserve(el) // 触发后停止观察
              }
            })
          },
          {
            threshold: 0.2 // 当20%元素可见时触发
          }
        )

        observer.observe(el)
      }
    }
  },
  created() {
    this.getDataList()
  },
  watch: {
    menuInfo(newVal) {
      this.menuInfo = newVal
      this.roleType = this.menuInfo.roleType
      this.getPession()
    },
    isLogin(val) {
      this.isLogin = val //true 登录  false 没登录
      this.getPession()
    }
  },
  data() {
    return {
      isLogin: null,
      showNone: false,
      roleType: [],
      menuCode: '10301',
      dataList: [],
      liveList: [],
      footerItem: null,
      dataItem: null,
      bannerItem: null,
      moocItem: [],
      spocItem: null,
      newsItem: null,
      teacherItem: null,
      teachingCenterItem: null,
      menuInfo: {},
      userInfo: null,
      zhsRole: 0,
      uuid: '',
      userId: '',
      lectureItem: null,
      virtualItem: null,
      visibleComponents: {
        banner: false,
        largeScreen: false,
        creditReform: false,
        appCenter: false,
        course: false,
        knowledge: false,
        spocCourse: false,
        AITeachApp: false,
        news: false,
        excellentVideo: false,
        teacherList: false,
        teacherData: false
      }
    }
  },
  methods: {
    setVisible(component, isVisible) {
      this.visibleComponents[component] = isVisible
      //   console.log(this.visibleComponents);
    },
    async getDataList() {
      const res = await this.$http.getDataList()
      console.log('首页数据', res)
      this.dataList = res
      this.bannerItem = res.find(item => item.function_id == '10302')
      this.moocItem = res.filter(item => item.function_id == '10401')
      this.spocItem = this.dataList.find(item => item.function_id == '10402')
      this.newsItem = res.find(item => item.function_id == '10701')
      this.teacherItem = res.find(item => item.function_id == '10501')
      this.dataItem = this.dataList.find(item => item.function_id == '10304')
    },
    getUserInfo(data) {
      this.userInfo = data
      this.uuid = data.uuid
      this.userId = data.id
    },
    getZhsRole(data) {
      this.zhsRole = data
      console.log(this.zhsRole, 'zhsRole')
    }
  }
}
</script>

<style lang="scss">
.animate-wrap {
  opacity: 0;
  transform: translateY(20px);
  transition: all 0.6s cubic-bezier(0.23, 1, 0.32, 1);
  transition-delay: 0.1s; /* 防闪烁 */
}
.animate-wrap.visible {
  opacity: 1;
  transform: translateY(0);
}
.home-list-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  &.back-img {
    background-image: url('https://image.zhihuishu.com/zhs/b2cm/base1/202507/64675d96de184b61b08501ea54086094.gif');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    &.back-img-1 {
      background-image: url('https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202507/1f9bf536e84e4aa791c9b5c77a97270e.gif');
    }
  }
  .mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.95);
    z-index: 0;
  }
}
</style>
